export const IS_DEV =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const IS_CONSOLE = window.location.hostname.startsWith("console.");
